import { useArgonController } from "context";
import { setMiniSidenav } from "context";
import Sidenav from "examples/Sidenav";
import { CustomDescrypt } from "global/func";
import { useEffect, useState } from "react";
import { decodeToken, isExpired } from "react-jwt";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import logo from "assets/images/logo-buton.png";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import userStore from 'store/userStore';
import TahunAnggaran from "pages/TahunAnggaran";
import superAdminRoutes from "./superAdminRoutes";
import KodefikasiPerencanaan from "./KodefikasiPerencanaan";
import KodefikasiRekening from "./KodefikasiRekening";
import SumberPendanaan from "./SumberPendanaan";
import DaftarOpd from "./DaftarOpd";
import Perencanaan from "./PerencanaanOPD";
import StrukturAnggaran from "./StrukturAnggaran";
import Laporan from "./Laporan";
import Belanja from "./PaketPekerjaan/Belanja";
import BelanjaModal from "./PaketPekerjaan/BelanjaModal";
import ProjekStrategis from "./PaketPekerjaan/ProjekStrategis";
import PaketDak from "./PaketPekerjaan/PaketDak";
import LokasiPekerjaan from "./LokasiPekerjaan";
import AnggaranOpd from "./AnggaranOpd";
import AdminOpd from "./Users/Opd";
import Admin from "./Users/Admin";
import Tkdn from "./Tkdn";
import Dashboard from "./Dashboard";

const TemplateSuperAdmin = () => {
    const { user, tahunAnggaran, reqCount } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, reqCount: state.reqCount }));
    const logOut = userStore((state) => state.logOut)
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const [decodedUser] = useState(decodeToken(decryptedUser));

    const navigate = useNavigate();
    const location = useLocation();
    const [controller, dispatch] = useArgonController();
    const { miniSidenav, sidenavColor } = controller;
    const [onMouseEnter, setOnMouseEnter] = useState(false);

    useEffect(() => {
        if (user === null || user === undefined || user === '') {
            navigate("/", { replace: true });
        }
        else {
            if (isExpired(decryptedUser)) {
                logOut()
                navigate("/", { replace: true });
            }
            else {
                if (decodedUser.role !== 'super_admin') {
                    navigate("/", { replace: true });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, location, reqCount])

    const handleOnMouseEnter = () => {
        if (miniSidenav && !onMouseEnter) {
            setMiniSidenav(dispatch, false);
            setOnMouseEnter(true);
        }
    };

    // Close sidenav when mouse leave mini sidenav
    const handleOnMouseLeave = () => {
        if (onMouseEnter) {
            setMiniSidenav(dispatch, true);
            setOnMouseEnter(false);
        }
    };
    
    return (
        tahunAnggaran === null ?
            <>
                <TahunAnggaran />
            </>
            :
            <>
                <Sidenav
                    color={sidenavColor}
                    brand={logo}
                    brandName="TEPRA Kab. Buton"
                    routes={superAdminRoutes}
                    onMouseEnter={handleOnMouseEnter}
                    onMouseLeave={handleOnMouseLeave}
                />
                <DashboardLayout>
                    <DashboardNavbar homePage='/admin' isMini={miniSidenav} user={decodedUser.nama + ' (' + decodedUser.nm_pd + ')' || ''} dinas={decodedUser.jabatan || ""} loginId={decodedUser.id || ''} />
                    <Routes>
                        <Route path="" element={<Dashboard />} />
                        <Route path="perencanaan/*" element={<Perencanaan />} />
                        <Route path="struktur-anggaran/*" element={<StrukturAnggaran />} />
                        <Route path="laporan/*" element={<Laporan />} />
                        <Route path="pdn/*" element={<Tkdn />} />
                        <Route path="belanja/*" element={<Belanja />} />
                        <Route path="belanja-modal/*" element={<BelanjaModal />} />
                        <Route path="projek-strategis/*" element={<ProjekStrategis />} />
                        <Route path="paket-dak/*" element={<PaketDak />} />
                        <Route path="lokasi-pekerjaan/*" element={<LokasiPekerjaan />} />
                        {/* <Route path="map-ai/*" element={<MapAI />} /> */}
                        <Route path="opd/*" element={<DaftarOpd />} />
                        <Route path="anggaran-opd/*" element={<AnggaranOpd />} />
                        <Route path="admin-opd/*" element={<AdminOpd />} />
                        <Route path="admin/*" element={<Admin />} />
                        <Route path="kodefikasi-perencanaan/*" element={<KodefikasiPerencanaan />} />
                        <Route path="kodefikasi-rekening/*" element={<KodefikasiRekening />} />
                        <Route path="sumber-pendanaan/*" element={<SumberPendanaan />} />
                    </Routes>
                </DashboardLayout>
            </>
    )
}

export default TemplateSuperAdmin